import React from 'react';
import { metrics } from '../data/content';
export function MetricsSection() {
  return <section aria-labelledby="metricas" className="border-y border-ink-600 bg-ink-800" data-id="element-127" data-mp="39t77he9i4kcj">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-16" style={{
      paddingTop: "12px",
      paddingBottom: "8px"
    }} data-id="element-128" data-mp="34tuox5pnxzfr">
        <h2 id="metricas" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-129" data-mp="2zvjfgw3a5qy2">
          Los números hablan
        </h2>

        <dl className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-ink-500 bg-ink-500 sm:grid-cols-2 lg:grid-cols-5" data-id="element-130" data-mp="1f6y0ftp3v40">
          {metrics.map((metric, index) => <div key={metric.label} className="flex flex-col justify-between bg-ink-900 p-6 text-center" data-id="element-131" data-mp="3nrdycag19k2p" data-mpi={index}>
              <dd className={`font-display leading-none ${index === 4 ? 'text-xl sm:text-2xl' : 'text-4xl sm:text-5xl'} ${index === 3 ? 'text-ball-400' : 'text-white'}`} data-id="element-132" data-mp="3it2pa1xkbdlj">
                {index === 3 ? `⭐ ${metric.value}` : metric.value}
              </dd>
              <dt className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-slate-400" data-id="element-133" data-mp="3jwe49lg9y6ub">
                {metric.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </section>;
}